import { clean } from '@/front/composables/StringComposer.js'
export default {
  mounted(el, binding) {
    const sanitized = clean(binding.value)
    el.innerHTML = sanitized
  },
  updated(el, binding) {
    const sanitized = clean(binding.value)
    el.innerHTML = sanitized
  }
}